<script lang="ts">
  import type { Snippet } from 'svelte';

  export type PillTone = 'plain' | 'good' | 'warn' | 'bad' | 'move' | 'accent';

  let {
    tone = 'plain',
    num = false,
    children,
  }: { tone?: PillTone; num?: boolean; children: Snippet } = $props();
</script>

<span class="pill {tone}" class:num>
  {@render children()}
</span>

<style>
  .pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 9px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    background: var(--viisi-surface-2);
    color: var(--viisi-ink-2);
    white-space: nowrap;
  }
  .pill.good { background: var(--viisi-good-soft); color: var(--viisi-good); }
  .pill.warn { background: var(--viisi-warn-soft); color: var(--viisi-warn); }
  .pill.bad { background: var(--viisi-bad-soft); color: var(--viisi-bad); }
  .pill.move { background: var(--viisi-move-soft); color: var(--viisi-move); }
  .pill.accent { background: var(--viisi-accent-soft); color: var(--viisi-accent); }
  .pill :global(svg) { width: 13px; height: 13px; }
</style>
